import { FiTrendingUp, FiTrendingDown } from "react-icons/fi";

const ConceptFeedback = ({ summary, message, trend }) => {
  const TrendIcon = trend === "behind" ? FiTrendingDown : FiTrendingUp;

  return (
    <div className="mx-2 text-sm">
      {summary && (
        <div className="flex items-center gap-2 py-2">
          {trend && <TrendIcon className="shrink-0" />}
          <span dangerouslySetInnerHTML={{ __html: summary }}></span>
        </div>
      )}
      {message && (
        <>
          <hr className="border-card_dark" />
          <div className="pt-3 pb-2">
            <div className="text-icon_alt mt-1" dangerouslySetInnerHTML={{ __html: message }}></div>
          </div>
        </>
      )}
    </div>
  );
};

export default ConceptFeedback;
